<script setup lang="ts">
defineOptions({
  name: "ErrorPage",
});
defineProps({
  videoName: {
    type: String,
    default: "",
  },
  message: {
    type: String,
    default: "",
  },
});
</script>

<template>
  <div class="i-tzj-player__error">
    <div class="i-tzj-player__error_content">
      {{ message }}
    </div>
  </div>
</template>
